module.exports = __webpack_public_path__ + "static/media/cleany-supply.936e1ce6.jpg";